// extracted by mini-css-extract-plugin
export default {"question":"br_df","titleLabel":"br_dw","prosCons":"br_dx","pros":"br_dy","cons":"br_dz"};